"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var enums_1 = require("./enums"); // support for inputs


var frontend_common_1 = require("@ryerson/frontend.common"); // support for address component


var Address_1 = require("../Address");

var FormWrapper = function FormWrapper(_ref) {
  var children = _ref.children,
      _ref$onSubmit = _ref.onSubmit,
      onSubmit = _ref$onSubmit === void 0 ? function (event, data) {} : _ref$onSubmit,
      _ref$onClear = _ref.onClear,
      onClear = _ref$onClear === void 0 ? function () {} : _ref$onClear;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isMounted = _ref3[0],
      setIsMounted = _ref3[1];

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      init = _ref5[0],
      setInit = _ref5[1];

  var _ref6 = (0, react_1.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      submitted = _ref7[0],
      setSubMitted = _ref7[1];

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      trackFormTrigger = _ref9[0],
      setTrackFormTrigger = _ref9[1];

  var _react_1$default$useS = react_1.default.useState(),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      displayChildren = _react_1$default$useS2[0],
      setDisplayChildren = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      clearFormTrigger = _react_1$default$useS4[0],
      setClearFormTrigger = _react_1$default$useS4[1]; // Array of form elements


  var formTracker = react_1.default.useRef([]); // Not using refs...leave this here for now
  // const creatDomNodeRef = (fieldName: string): React.RefObject<any> => {
  // 	if (!domNodeRefs[fieldName]) domNodeRefs[fieldName] = React.createRef();
  // 	return domNodeRefs[fieldName];
  // };

  var cloneChildWithProps = function cloneChildWithProps(child, index) {
    var props = child.props,
        _child$props = child.props,
        checked = _child$props.checked,
        value = _child$props.value,
        label = _child$props.label,
        _child$props$name = _child$props.name,
        name = _child$props$name === void 0 ? "" : _child$props$name,
        _child$props$required = _child$props.required,
        isRequired = _child$props$required === void 0 ? false : _child$props$required,
        displayName = child.type.displayName; //input name prop check

    !name && (name = "form_input_".concat(displayName === null || displayName === void 0 ? void 0 : displayName.toLowerCase(), "_").concat(index)); //const refName = `input-${index++}`;

    var childProps = {};
    var validationCheck = true;

    switch (displayName) {
      case enums_1.FormWrapperInputs.Checkbox:
        value = checked ? value : "";
        break;

      case enums_1.FormWrapperInputs.GroupCheckbox:
        value = props.values;
        break;

      case enums_1.FormWrapperInputs.Address:
        value = props.inputValues;
        break;

      default:
        value = props.value;
    } // Submit Button


    if (displayName === enums_1.FormWrapperButtons.Submit) {
      childProps = {
        onClick: function onClick() {
          if (!submitted) {
            setSubMitted(true);
          } else {
            setTrackFormTrigger(!trackFormTrigger);
          }

          props.onClick && props.onClick();
        }
      }; // Clear Button
    } else if (displayName === enums_1.FormWrapperButtons.Clear) {
      childProps = {
        onClick: function onClick() {
          setClearFormTrigger(!clearFormTrigger);
          props.onClick && props.onClick();
        }
      }; // Allowed Form Input
    } else {
      validationCheck = !submitted ? true : isInputValid(displayName, value, isRequired);
      childProps = {
        isValid: validationCheck,
        submitted: submitted // inputRef: creatDomNodeRef(refName)
        // may need this next sprint leave for now
        // componentRef: creatComponentRef(refName, Input),

      };
    }

    var newChild = react_1.default.cloneElement(child, childProps, children); // DEBUG
    // (newChild?.type as any)["displayName"].indexOf("FormWrapper") === -1 &&
    // 	console.log("* CloneChild ", (newChild?.type as any)["displayName"], newChild);

    formTracker.current.push({
      isError: !validationCheck,
      label: label,
      name: name,
      value: value
    });
    return newChild;
  }; // Determines if this a valid form input to modify with validation props or just regular JSX to echo back
  // See Enum FormWrapperInputs which defines the inputs to use.


  function isFormInput(child) {
    var _a;

    var childType = typeof (child === null || child === void 0 ? void 0 : child.type);
    if (!childType) return false;
    return Object.values(enums_1.FormWrapperInputs).indexOf((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) > -1;
  } // Recursive function for parsing all JSX children


  var recurseChildren = function recurseChildren(childArray) {
    var recurseIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var index = recurseIndex > -1 ? recurseIndex : 0;
    var newChildren = react_1.default.Children.map(childArray, function (child) {
      var _child$props2 = child.props;
      _child$props2 = _child$props2 === void 0 ? {} : _child$props2;
      var _child$props2$childre = _child$props2.children,
          children = _child$props2$childre === void 0 ? null : _child$props2$childre;
      /*
      //  DEBUG ~ Child Type LEAVE HERE FOR NOW
      console.log(
          "\n *Child.type.displayName: ",
          (child?.type as any).displayName,
          //`\n isObject  ${typeof child === "object"}\n`,
          child,
          "\n"
          //typeof child.__proto__ === "object" && child.__proto__ instanceof Object
          //child.__proto__.isPrototypeOf(ToggleButton.__proto__)
      );
      */
      // Recurse if child has children

      if (children) {
        children = recurseChildren(children, index++);
      }

      if (isFormInput(child)) {
        return cloneChildWithProps(child, index);
      } else if (child.type) {
        return react_1.default.cloneElement(child, child.props, children);
      } else {
        return child;
      }
    });
    return newChildren;
  }; // Specific Validation for each type


  var isInputValid = function isInputValid(displayName, inputValue, required) {
    var valid = true;
    if (!required) return valid;

    switch (displayName) {
      case enums_1.FormWrapperInputs.ToggleButton:
        valid = !!inputValue.trim(); //this is not currently being recognized

        break;

      case enums_1.FormWrapperInputs.Dropdown:
      case enums_1.FormWrapperInputs.Input:
        valid = !!inputValue.trim();
        break;

      case enums_1.FormWrapperInputs.PhoneInput:
        valid = !(0, frontend_common_1.validatePhone)(inputValue, required);
        break;

      case enums_1.FormWrapperInputs.EmailInput:
        valid = !(0, frontend_common_1.validateEmail)(inputValue, required);
        break;

      case enums_1.FormWrapperInputs.GroupCheckbox:
        valid = Array.isArray(inputValue) && inputValue.length > 0;
        break;

      case enums_1.FormWrapperInputs.Address:
        for (var _i = 0, _Object$keys = Object.keys(Address_1.RequiredInputs); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          valid = (0, Address_1.validateAddressInput)(key, inputValue[key], inputValue.country);
          if (!valid) break;
        }

        break;

      default:
    }

    return valid;
  };

  var prepareForm = function prepareForm() {
    formTracker.current = [];
    var formChildren = recurseChildren(Array.isArray(children) ? children : [children]);
    setDisplayChildren(formChildren);
  };

  var checkFormSubmitted = function checkFormSubmitted() {
    var hasIssues = formTracker.current.some(function (formInput) {
      return formInput.isError === true;
    });

    if (hasIssues) {
      onSubmit({});
    } else {
      onSubmit(formTracker.current.reduce(function (formObj, item) {
        (item === null || item === void 0 ? void 0 : item.name) && (formObj[item === null || item === void 0 ? void 0 : item.name] = item === null || item === void 0 ? void 0 : item.value);
        return formObj;
      }, {}));
    }
  };

  (0, react_1.useEffect)(function () {
    if (isMounted && init) {
      setSubMitted(false);
      onClear();
      prepareForm();
    }
  }, [clearFormTrigger]); // Additional click(s) of submit

  (0, react_1.useEffect)(function () {
    if (isMounted && init) {
      checkFormSubmitted();
    }
  }, [trackFormTrigger]); // For Initial Submit

  (0, react_1.useEffect)(function () {
    if (isMounted && init && submitted) {
      prepareForm();
      checkFormSubmitted();
    }
  }, [submitted]);
  (0, react_1.useEffect)(function () {
    if (isMounted && init) {
      prepareForm();
    }
  }, [children]); // on mount

  (0, react_1.useEffect)(function () {
    if (isMounted) {
      prepareForm();
      setInit(true);
    }
  }, [isMounted]);
  (0, react_1.useEffect)(function () {
    setIsMounted(true);
  }, []);
  return (0, jsx_runtime_1.jsx)("form", {
    className: "form-wrapper-component",
    children: displayChildren
  });
};

exports.default = FormWrapper;